class ConfiguratorVariant {
    constructor() {
        this.id = 'variant';
        this.cache = {};
        this.sizes = [];

        this.selectors = [
        ];

        for (const sel of this.selectors) {
            // configurator.addSelectorItem(sel);
        }

        this.init();
    }

    async init() {
    }

    isValidSelector(selector) {
        return ['size', 'color'].includes(selector);
    }
    
    setupListeners() {
    }

    async refresh(selector) {
        if (Object.keys(this.cache).length == 0) {
            await this.loadBuyables();

            for (const sel of this.selectors) {
                configurator.addSelectorItem(sel);
            }

            if (this.selectors.includes('size') && !(configurator.selection.size in this.cache)) {
                configurator.selection.size = Object.keys(this.cache)[0];
            }
        }
        
        if (this.selectors.includes('size')) { this.populateSizes(); }
        if (this.selectors.includes('color')) { this.populateColors(); this.filterVariantImages(); }
    }

    populateSizes() {
        const items = [];

        // Sort sizes numerically, keeping ST variants after their non-ST counterpart
        var sizesSorted = [].slice.call(Object.keys(this.cache)).sort((a, b) => {
            const a1 = a.replace('st', '').split('x');
            const b1 = b.replace('st', '').split('x');
            const numSort = a1[0] - b1[0] || a1[1] - b1[1];
            if (numSort !== 0) return numSort;
            return a.endsWith('st') ? 1 : -1;
        });

        for (const size of sizesSorted) {
            const isST = size.endsWith('st');
            const label = isST
                ? size.replace('st', '').replace('x', ' x ') + ' ST'
                : size.replace('x', ' x ');
            items.push({
                'id': size,
                'label': label,
                'thumbnail': null,
            });
        }
        
        configurator.renderSelector('size', items, {
            'columns': 5, 
            'allow_none': false
        });
    }

    populateColors() {
        const items = [];
        const sizeEntry = this.selectors.includes('size') ? this.cache[configurator.selection.size] : null;
        const variants = sizeEntry ? sizeEntry.items : this.cache;

        for (const id in variants) {
            const variant = variants[id];

            items.push({
                'id': variant.color,
                'label': variant.color,
                'thumbnail': null,
            });
        }
        
        configurator.renderSelector('color', items, {
            'columns': 5, 
            'allow_none': false
        });

        if (configurator.selection.color == null) {
            configurator.selection.color = Object.keys(variants)[0];
        }
        if (configurator.selection.color != null) { configurator.updateSelectorState( 'color' ); }
    }

    async loadBuyables() {
        console.log("Starting loadBuyables for product ID:", bed_configuration.product);

        // Non-fabric headboard products (plain Pinnö/Ottero) are separate Shopify products
        // per size. Load all sizes from the collection instead of just the single product.
        const category = (bed_configuration.category || '').toLowerCase();
        if (bed_configuration.collection && (category.includes('pinno') || category.includes('ottero')) && !category.includes('salo')) {
            await this.loadBuyablesFromCollection();
            return;
        }

        const product = await configurator.loadProductVariantData("gid://shopify/Product/"+bed_configuration.product, ['width', 'height', 'length'], true);
        console.log("Received product data:", product);
        console.log("Variants:", product.variants);
        
        const urlParams = new URLSearchParams(window.location.search);
        const variant_id = urlParams.get('variant');

        // Check if product has variants before proceeding
        if (!product.variants || product.variants.length === 0) {
            console.error('No product variants found for product ID:', bed_configuration.product);
            return;
        }

        const unique_opts = Object.values(product.variants)[0];
        // Check all items for variants in size/color options
        for (const opt of ['size', 'color']) {
            for (const v of product.variants) {
                if (v[opt] != unique_opts[opt]) {
                    this.selectors.push(opt);
                    break;
                }
            }
        }
        
        console.log("Selected option selectors:", this.selectors);
        
        for (const variant of product.variants) {
            // Skip variants with price 0 when e-commerce is enabled
            if (variant.price == 0 && configurator.enable_ecommerce == true) { continue; }
            
            const color = this.selectors.includes('color') ? variant.color.toLowerCase() : 'default';

            if (this.selectors.includes('size')) {
                if (!(variant.size in this.cache)) {
                    this.cache[ variant.size ] = { 'title': variant.size, 'items': {} };
                }
                this.cache[ variant.size ].items[ color ] = configurator.variantToItem(product, variant);
                this.cache[ variant.size ].items[ color ].color = variant.color;
                this.cache[ variant.size ].items[ color ].dimensions = [
                    this.safelyDivideToCm(product.width),
                    this.safelyDivideToCm(product.length),
                    this.safelyDivideToCm(product.height)
                ];
            } else {
                this.cache[ color ] = configurator.variantToItem(product, variant);
                this.cache[ color ].label = variant.color;
                this.cache[ color ].color = color;
                this.cache[ color ].dimensions = [
                    this.safelyDivideToCm(product.width),
                    this.safelyDivideToCm(product.length),
                    this.safelyDivideToCm(product.height)
                ];
            }
            if (variant.id && variant.id.replace('gid://shopify/ProductVariant/', '') == variant_id) {
                let variantSelectedFromUrl = false; // Flag to track if a variant was matched from URL
                // Set fabric, size, variant selections
                for (const s of this.selectors) {
                    if (s === 'color' && typeof variant[s] === 'string') {
                        configurator.selection[s] = variant[s].toLowerCase();
                        variantSelectedFromUrl = true; // Color processed from URL variant
                    } else {
                        configurator.selection[s] = variant[s];
                    }
                }

                if (variantSelectedFromUrl) { // Only update URL if a variant (specifically color) was matched and processed from URL
                    configurator.updateUrlParams();
                }
            }
        }
        
        console.log("Cache after loading variants:", this.cache);
    }

    async loadBuyablesFromCollection() {
        const collection = 'configurator-' + bed_configuration.collection;
        const category = bed_configuration.category;

        console.log(`[VARIANT] Loading non-fabric headboard sizes from collection: ${collection}, category: ${category}`);

        const products = await configurator.loadProductData(collection, [
            {key: 'category', value: category},
        ], ['size', 'width', 'height', 'length'], true);

        console.log(`[VARIANT] Loaded ${products.length} products from collection`);

        if (products.length === 0) return;

        this.selectors.push('size');

        for (const product of products) {
            if (product.variants[0].price == 0 && configurator.enable_ecommerce == true) continue;

            const variant = product.variants[0];
            const size = product.size;
            if (!size) continue;

            // ST (side table) variants share the same size metafield as non-ST.
            // Differentiate by appending 'st' to the cache key.
            const isST = product.productid && product.productid.endsWith('st');
            const sizeKey = isST ? size + 'st' : size;

            if (!(sizeKey in this.cache)) {
                this.cache[sizeKey] = { 'title': sizeKey, 'items': {} };
            }

            const item = configurator.variantToItem(product, variant);
            item.available = true;
            item.productid = product.productid;
            item.dimensions = [
                this.safelyDivideToCm(product.width),
                this.safelyDivideToCm(product.length),
                this.safelyDivideToCm(product.height)
            ];
            this.cache[sizeKey].items['default'] = item;
        }

        // Set default size to the current product's size if available
        const sizes = Object.keys(this.cache);
        if (sizes.length > 0 && !configurator.selection.size) {
            configurator.selection.size = sizes[0];
        }

        console.log("[VARIANT] Cache after loading from collection:", this.cache);
    }

    isSoldOut() {
        // Non-fabric headboards (plain Pinnö/Ottero) should never block purchase
        const category = (bed_configuration.category || '').toLowerCase();
        if ((category.includes('pinno') || category.includes('ottero')) && !category.includes('salo')) {
            return false;
        }

        let item = null;
        const color = this.selectors.includes('color') && configurator.selection.color ? configurator.selection.color.toLowerCase() : 'default';

        if (this.selectors.includes('size')) {
            item = this.cache[ configurator.selection.size ].items[ color ];
        } else {
            item = this.cache[ color ];
        }

        if (item && item.available) return false;
        return true;
    }

    getPriceData(priceData) {
        // Load base with specific fabric
        let item = null;
        const color = this.selectors.includes('color') && configurator.selection.color ? configurator.selection.color.toLowerCase() : 'default';

        if (this.selectors.includes('size')) {
            item = this.cache[ configurator.selection.size ].items[ color ];
        } else {
            item = this.cache[ color ];
        }

        if (item != null && item.skus != null) {
            const price = item.price ?? 0;
            console.log("furniture"+" => "+item.id+" => "+price);
            priceData.total += price;
            priceData.skus.push(...item.skus);
            priceData.ids.push(...item.ids);

            const dimensionsElement = document.querySelector('.dimensions');
            if (dimensionsElement && item.dimensions && item.dimensions.some(d => d > 0)) {
                dimensionsElement.querySelector('.dimensions-value').textContent = "B x L x H: " + item.dimensions.join(' x ') + " cm";
                dimensionsElement.hidden = false;
            } else if (dimensionsElement) {
                dimensionsElement.hidden = true;
            }
        }
    }

    getCylindoSpecs(specs) {
        const category = (bed_configuration.category || '').toLowerCase();

        // Non-fabric Pinnö/Ottero headboard sizing
        if ((category.includes('pinno') || category.includes('ottero')) && !category.includes('salo')) {
            if (configurator.selection.size) {
                const isST = configurator.selection.size.endsWith('st');
                const sizeClean = configurator.selection.size.replace('st', '');
                let width = sizeClean.split('x')[0];

                if (category.includes('pinno') && width === '282') {
                    specs.features.SIZE = `282 CM ${isST ? 'WITH' : 'WITHOUT'} SIDE TABLE NO PANEL`;
                } else {
                    specs.features.SIZE = width;
                }
            }
            return;
        }

        const color_mapping = {
            'holme nightstand': {
                'black': 'CLASSIC_BLACK',
                'chrome': 'CHROME',
                'brass': 'BRASS',
                'walnut': 'HOLMECLASSIC IN WALNUT',
                'walnut door': 'HOLMEDOOR IN WALNUT',
                'walnut left': 'HOLMEDOOR IN WALNUT',
                'walnut right': 'HOLMEDOOR IN WALNUT',
                'walnut high': 'HOLMEDOORHIGH IN WALNUT',
                'walnut high left': 'HOLMEDOORHIGH IN WALNUT',
                'walnut high right': 'HOLMEDOORHIGH IN WALNUT'
            },
        };
        const size_mapping = {
            'prestige topper': { 'default': '200x90', '>105': '200x140', '>140': '200x180' },
            'premium topper': { 'default': '200x90', '>105': '200x140', '>140': '200x180' },
        }

        const color = configurator.selection.color ? configurator.selection.color.toLowerCase() : 'default';
        const model = bed_configuration.cylindo_model.toLowerCase();

        if (model in color_mapping && color in color_mapping[model]) {
            specs.features['bedside table'] = color_mapping[model][color].toUpperCase();
        }
        
        if (model in size_mapping) {
            const size_arr = configurator.selection.size.split('x');
            let width = parseInt(size_arr[0]);
            let model_size = '';

            for (const key in size_mapping[model]) {
                console.log("Test: "+width +"+"+ key);
                if (key == 'default' || eval(width + key)) {
                    console.log("OK");
                    model_size = size_mapping[model][key];
                }
            }
            
            specs.features.size = model_size.toUpperCase();
        }
    }

    safelyDivideToCm(value) {
        if (!value || isNaN(parseFloat(value))) return 0;
        return parseFloat(value) / 10;
    }

    filterVariantImages() {
        if (configurator.selection.color == null) { return; }

        const selectedColor = configurator.selection.color.toLowerCase();
        const disabled_media = document.querySelector('.disabled-media');
        const baseAltPrefix = 'variant '; // Define the prefix for matching

        // Remove variant images that do not match selected color
        const items = document.querySelectorAll('cylindo-viewer cylindo-custom-content');
    
        for (const elm of items) {
            const img = elm.firstElementChild;
            
            if (img.alt && img.alt.toLowerCase().includes('variant')) {
                // Extract the color part after "variant " from the alt text
                const altText = img.alt.toLowerCase();
                const altColor = altText.startsWith(baseAltPrefix) ? 
                                altText.substring(baseAltPrefix.length) : '';
                
                // Only move to disabled if it's not an exact match
                if (altColor !== selectedColor) {
                    var wrapper = document.createElement('div');
                    wrapper.innerHTML = elm.outerHTML.replace('<cylindo-custom-content', '<div').replace('</cylindo-custom-content>', '</div>');
                    disabled_media.appendChild(wrapper.firstElementChild);
                    elm.remove();
                }
            }
        }
    
        // Return variant images that exactly match selected color
        const disabled_items = document.querySelectorAll('.disabled-media div');
        
        for (const elm of disabled_items) {
            const img = elm.firstElementChild;
        
            if (img.alt && img.alt.toLowerCase().includes('variant')) {
                // Extract the color part after "variant " from the alt text
                const altText = img.alt.toLowerCase();
                const altColor = altText.startsWith(baseAltPrefix) ? 
                                altText.substring(baseAltPrefix.length) : '';
                
                // Only return to viewer if it's an exact match
                if (altColor === selectedColor) {
                    var wrapper = document.createElement('div');
                    wrapper.innerHTML = elm.outerHTML.replace('<div', '<cylindo-custom-content').replace('</div>', '</cylindo-custom-content>');
                    configurator.viewer.appendChild(wrapper.firstElementChild);
                    elm.remove();
                }
            }
        }
    
        configurator.viewer.__requestUpdate();
    }
}
